
import React, { useContext } from 'react'
import { motion } from 'framer-motion';
import { saveAs } from 'file-saver';
import { toast } from 'react-hot-toast'
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useCatalogue } from "../components/context/CatalogueWrapper";
import { FormattedMessage, useIntl } from "react-intl";
import NoImage from '../assets/no-image.png'
import { Context } from '../components/context/LanguageWrapper';
import { isColorCardUploaded } from '../functions/helpers';

const CatalogColor = ({ color }) => {

  const intl = useIntl();

  const context = useContext(Context)

  const userLogin = useSelector(state => state.userLogin)
  const { userDetails } = userLogin

  const { selectedCatalogues, toggleCatalogueSelection } = useCatalogue();

  const handleClick = () => {
    toggleCatalogueSelection(color);
  }

  const handleFileDownload = async (color_card_id) => {

    const headers = {
      responseType: 'arraybuffer',
      headers: {
        "x-auth-token": userDetails.token,
      }
    };

    await axios.get(process.env.REACT_APP_API_ENDPOINT + `/color_cards/${color_card_id}/download/${context.locale.slice(0, 2)}`, headers)
      .then(response => {
        let fileBlob = new Blob([response.data], { type: "application/pdf" });
        if (fileBlob.size < 1000) {
          toast.error("File mancante")
        } else {
          saveAs(fileBlob, `${color?.name}_${context.locale.slice(0, 2)}.pdf`);
          toast.success(<FormattedMessage id="app.general.downloaded" defaultMessage="Downloaded" />)
        }
      })
      .catch(error => toast.error(error));

  }

  return (
    <>
      <div className='rounded border border-secondary z-20 mb-4'>
        <motion.div className="flex flex-row justify-between bg-gray-200 hover:bg-gray-300 border border-secondary hover:border-2 hover:border-green-900 cursor-pointer z-0"
          onClick={handleClick}
          whileHover={{ scale: 0.998 }}
          whileTap={{ scale: 1.0 }}>
          <div className="flex flex-row gap-2">
            <div className="h-16 w-16 rounded p-1">
              {color?.thumbnail !== '' ? (<img className='object-cover aspect-square rounded' src={color?.thumbnail}></img>) : (<img className="object-contain rounded-md" src={NoImage} />)}
            </div>
            <div>
              <div className="text-xl font-bold text-green-900">{color.name}</div>
            </div>
          </div>
          {selectedCatalogues.some(sel => sel === color.id) &&
            <div className="pr-2 text-sm font-medium text-green-600">{intl.formatMessage({ id: "app.catalog.form.selected", defaultMessage: 'SELECTED' })}</div>
          }
        </motion.div>
        <div className='flex place-content-end'>
          {isColorCardUploaded(color.pdf_url) ?
            <button className='text-white bg-green-900 py-1 px-10 rounded z-10' onClick={() => handleFileDownload(color.id)}><i className="fa-sharp fa-solid fa-download"></i>
            </button> : <button className='text-white bg-red-900 py-1 px-10 rounded' disabled><i className="fa-sharp fa-solid fa-download"></i>
            </button>
          }

        </div>
      </div>
    </>
  )
}

export default CatalogColor
